import { IconButton, IconButtonProps, Tooltip } from '@wix/design-system';
import classNames from 'classnames';
import React, { FC } from 'react';

import { shouldShowNewHomePage } from '../../../util/isNewHomePage';
import { renderModel } from '../../../util/renderModel';
import s from './styles.scss';

const isStudioEditor = renderModel.isStudioEditor();
const isEditor3 = renderModel.isEditor3();

type HeaderActionsIconProps = IconButtonProps & {
  children: React.ReactNode;
  tooltipContent?: string;
};

export const HeaderActionsIcon: FC<HeaderActionsIconProps> = ({
  children,
  tooltipContent,
  ...iconButtonProps
}) => {
  const isNewHomePage = shouldShowNewHomePage();
  const isMobile = renderModel.isMobile();
  const iconButton = (
    <IconButton
      size={isNewHomePage ? 'small' : 'medium'}
      skin={'transparent'}
      {...iconButtonProps}
      className={classNames(s.headerActionsIcon, {
        [s.studioEditor]: isStudioEditor,
        [s.editor3]: isEditor3,
      })}
    >
      {children}
    </IconButton>
  );

  const shouldWrapWithTooltip = !isMobile && Boolean(tooltipContent);

  return (
    <>
      {shouldWrapWithTooltip ? (
        <Tooltip
          content={tooltipContent}
          size="small"
          className={classNames({ [s.studioEditorTooltip]: isStudioEditor })}
        >
          {iconButton}
        </Tooltip>
      ) : (
        iconButton
      )}
    </>
  );
};
